export const getExternalToolbarId = (resourceId, formName) => `${resourceId}-${formName}`;
export const getPlaceholderKey = (props) => {
    if (props.isReply) {
        return 'comment-box.placeholder-reply';
    }
    return props.withRating && props.isMobile && !props.isExpanded
        ? 'comment-box.placeholder-ratings'
        : 'comment-box.placeholder';
};
export const waitForAnimationEnd = (node) => new Promise((resolve) => {
    node.addEventListener('transitionend', resolve, {
        once: true,
    });
    setTimeout(resolve, 500);
});
export const formatLabel = (label, isRequired) => `${label}${isRequired ? '*' : ''}`;
//# sourceMappingURL=comment-box.utils.js.map